/**
 * Where an agent's navigate action goes (CINCHAI-109). The proxy streams `{kind: 'navigate', key, path,
 * label}` (key and path the same page) and saved replies keep `path` only, so the client check and the
 * route both read `path` (Chris's review of FE #2325): the page that is re-checked is the page that opens.
 *
 * `findPage(path)` is page-registry's lookup and `ctx` the sidebar's predicate argument. Returns
 * `{ path }` to open, or `{ reason }` the user is told instead.
 */
export function navigateTarget(action, findPage, ctx) {
  const path = typeof action?.path === 'string' ? action.path : '';
  const page = path ? findPage(path) : null;
  let allowed = !!page;
  if (page?.enabled) {
    try {
      allowed = !!page.enabled(ctx);
    } catch (e) {
      allowed = false; // a predicate that can't answer is a no, like allowedPages()
    }
  }
  if (!allowed) return {
    reason: `You don't have access to ${action?.label || path || 'that page'}.`
  };
  return {
    path: page.key
  };
}